import {Http, TokenManager, Session, Storage} from "vuezx";

function apiFactory({url, commit, setCommit, config}) {
  return Http.get({
    baseURL: global.API_BASE_PATH,url: global.setUrl(url, config.params ? config.params : {}, true),
    success: (response) => {
      if (response.message == "success") {
        if (config.hasOwnProperty("success")) config.success(response.data);
      } else {
        if (config.hasOwnProperty("nosuccess")) config.nosuccess(response);
      }
    },
    complete: (response) => {
      if (commit) {
        commit(setCommit, response.data ? response.data : null);
      }
      if (config.hasOwnProperty("complete")) config.complete(response);
    },
    fail: (response) => {
      if (config.hasOwnProperty("fail")) config.fail(response);
    },
    error: (response) => {
      if (config.hasOwnProperty("error")) config.error(response);
    }
  });
}

const app = {
  state: {
    // 加载
    isLoading: false,
    // 用户信息
    userInfo: "",
    // 输出token是否过期
    tokenState: "",
    // 输出默认宝宝信息
    defaultBabyInfo: "",
    // 输出默认孩子信息
    defaultChildInfo: "",
    // 国家
    country: null,
    // 保存按钮高亮
    saveFlag: false
  },
  mutations: {
    // 加载
    showLoading(state, value) {
      state.isLoading = value;
    },
    // 用户信息
    setUserInfo: (state, data) => {
      state.userInfo = data;
    },
    // 设置默认宝宝信息
    setDefaultBabyInfo: (state, data) => {
      state.defaultBabyInfo = data;
    },
    // 设置默认孩子信息
    setDefaultChildInfo: (state, data) => {
      state.defaultChildInfo = data;
    },
    // 验证token是否过期
    setTokenState: (state, data) => {
      state.tokenState = data;
    },
    // 设置国家
    setCountry: (state, data) => {
      state.country = data;
    },
    // 保存按钮高亮
    setSaveFlagVal(state, value) {
      state.saveFlag = value;
    },
  },
  actions: {
    // 加载
    showLoading({commit}, value) {
      commit("showLoading", value);
    },
    // 保存按钮高亮
    setSaveFlag({commit}, value) {
      commit("setSaveFlagVal", value);
    },
    // 获取文章详情
    getDocDetail({commit}, config) {
      let params = {
        url: "/doc/get",
        config: config
      };
      return apiFactory(params);
    },
    // 获取主题文章
    getListByTopic({commit}, config) {
      let params = {
        url: "/doc/getListByTopic",
        config: config
      };
      return apiFactory(params);
    },
    // 获取主题详情
    getThemeDetail({commit}, config) {
      let params = {
        url: "/topic/get",
        config: config
      };
      return apiFactory(params);
    },
    // 获取主题列表
    getThemeList({commit}, config) {
      let params = {
        url: "/topic/getList",
        config: config
      };
      return apiFactory(params);
    },
    // 请求用户信息
    userInit({commit}, config) {
      let params = {
        commit: commit,
        setCommit: "setUserInfo",
        url: "/account/getUser",
        config: config
      };
      return apiFactory(params);
    },
    // 请求默认宝宝信息
    defaultBabyInit({commit}, config) {
      let params = {
        commit: commit,
        setCommit: "setDefaultBabyInfo",
        url: "/account/getDefaultBaby",
        config: config
      };
      return apiFactory(params);
    },
    // 请求默认孩子信息
    defaultChildInit({commit}, config) {
      let params = {
        commit: commit,
        setCommit: "setDefaultChildInfo",
        url: "/account/getDefaultChild",
        config: config
      };
      return apiFactory(params);
    },
    // 获取服务所需参数
    routeInit({commit}, config) {
      return Http.get({
        baseURL: global.API_BASE_PATH,url: global.setUrl('/home/route', config.params, false),
        success: (response) => {
          if (response.message == "success" && response.data) {
          } else {
            global.showError(response.message)
          }
        }
      })
    },
    // 验证token是否过期 并且存储
    checkTokenInit({commit}, config) {
      // 平台或者艾嘉跳转
      let appFlag = global.appTokenFlag(config.to)
      // 还未登录授权
      if (!TokenManager.get()) {
        if (appFlag) {
          // app登录
          global.getAppToken(config.success, config.to);
        } else {
          // 微信授权
          global.authorize(0, null, config.to);
          config.success()
        }
      }
      // 
      else {
        config.params = {}
        // app登录    
        if (appFlag) {
          // 存储的参数
          let npLoginParams = Session.get('npLoginParams')
          if (npLoginParams) {
            Object.assign(config.params, npLoginParams)
            // app登录 npVerifyToken verifyToken 为空
            if ((!npLoginParams.npToken && npLoginParams.hasOwnProperty("npToken")) || (!npLoginParams.ijToken && npLoginParams.hasOwnProperty("ijToken"))) {
              // app登录或者跳转健康城市中转站
              global.appLogin(config)
              return
            }
          } else {
            // app登录或者跳转健康城市中转站
            global.appLogin(config)
          }
        }
        //app登录 npVerifyToken verifyToken 不为空 或者微信授权
        // 检验token是否失效
        Http.get({
          baseURL: global.API_BASE_PATH,url: global.setUrl('/account/checkToken', config.params, false),
          success: (response) => {
            if (response.message == "success" && response.data) {
              commit('setTokenState', true);
              config.success(response.data)
            }
            // token失效
            else {
              commit('setTokenState', false);
              if (!response.data) {
                if (appFlag) {
                  // app登录
                  global.getAppToken(config.success, config.to);
                } else {
                  // 微信授权
                  global.authorize(0, null, config.to);
                  config.success(response.data)
                }
              }
            }
          }
        })
      }
    },
    // 从app进入请求token
    loginInit({commit}, config) {
      Http.get({
        baseURL: global.API_BASE_PATH,url: global.setUrl(config.url, config.params, true, true),
        success: (response) => {
          if (response.message == "success") {
            TokenManager.set(response.data.token);
            global.showSuccess('登录成功')
            config.success(response.data);
          } else {
            // 加载结束
            commit("showLoading", false);
            global.showError(response.message)
            // token失效
            // app登录或者跳转健康城市中转站
            global.appLogin(config)
          }
        }
      })
    },
    // 请求默认国家
    defaultCountryList({commit}, config) {
      let params = {
        commit: commit,
        setCommit: "setCountry",
        url: "/zyfy/getCountryCode",
        config: config
      };
      return apiFactory(params);
    }
  }
};

export default app;
